import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { WorkingHoursFacade } from './working-hours.facade';

@Injectable({
  providedIn: 'root',
})
export class WorkingHoursGuard {
  constructor(private workingHoursFacade: WorkingHoursFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.workingHoursFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.workingHoursFacade);
  }
}
